import {
  List,
  Calendar,
  MessagesSquare,
  Handshake,
  CheckSquare,
  FileText,
  Video,
  Building2,
  MousePointerClick,
} from "lucide-react";
import { ChartBarIcon } from "@heroicons/react/20/solid";
import { useMemo } from "react";
import { useWorkspaceObjectsDetailed } from "../../../../../hooks/QueryHooks";
import useWorkspaceStore from "../../../../../store/workspace/workspaceStore";
import OverflowTabBar, { TabDefinition } from "../../../../../shared/ui/tabs/OverflowTabBar";

type UserRoutesProps = {
  className?: string;
};

const CORE_TABS: TabDefinition[] = [
  { to: "activity", label: "Activity", icon: MousePointerClick as any },
  { to: "traits", label: "Traits", icon: List as any },
];

const DEDICATED_ROUTE_BY_SLUG: Record<string, string> = {
  conversations: "emails",
  meetings: "calendar",
};

const EXCLUDED_SLUGS = new Set(["accounts", "users", "conversation_messages"]);

const ICON_BY_SLUG: Record<string, React.ComponentType<any>> = {
  conversations: MessagesSquare,
  meetings: Calendar,
  meeting_recordings: Video,
  deals: Handshake,
  tasks: CheckSquare,
  notes: FileText,
  companies: Building2,
};

const UserRoutes = ({ className = '' }: UserRoutesProps) => {
  const workspaceId = useWorkspaceStore((state) => state.workspace?.id);

  const { data: workspaceObjects } = useWorkspaceObjectsDetailed({
    workspaceId: workspaceId || "",
    enabled: !!workspaceId,
  }) as any;

  const tabs = useMemo(() => {
    const objectTabs: TabDefinition[] = [];

    if (workspaceObjects) {
      const objects = Array.isArray(workspaceObjects) ? workspaceObjects : [];
      objects
        .filter((obj: any) => obj.enabled && !EXCLUDED_SLUGS.has(obj.api_slug))
        .sort((a: any, b: any) => (a.display_order ?? 0) - (b.display_order ?? 0))
        .forEach((obj: any) => {
          const slug: string = obj.api_slug;
          const route = DEDICATED_ROUTE_BY_SLUG[slug] || `objects/${slug}`;
          const icon = ICON_BY_SLUG[slug];

          objectTabs.push({
            to: route,
            label: obj.display_name || obj.plural_noun || slug,
            ...(icon ? { icon: icon as any } : {}),
          });
        });
    }

    return [...CORE_TABS, ...objectTabs];
  }, [workspaceObjects]);

  return <OverflowTabBar tabs={tabs} className={className} />;
};

export default UserRoutes;
